
const list = document.getElementById('func-list');
if (list) {
  // Funcion para verificar si el scroll esta activo
  const observer = new ResizeObserver(() => {
    if (list.scrollWidth > list.clientWidth) {
      list.classList.add('scroll-active');
    } else {
      list.classList.remove('scroll-active');
    }
  });

  observer.observe(list);
}
